import axios from "axios";
import attributes from "../../models/workflow/attributes";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAttributes() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/opermgr`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return attributes.fromJson(item);
        });
      });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      operId: data.operId,
      nivelId: data.nivelId,
      fecDesde: data.fecDesde,
    };

    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.to && !data.haNoEx) {
      payload = {
        ...payload,
        fecHasta: data.to + "T00:00:00.000Z",
      };
    }

    return axios.post(`${url}/workflow/opermgr`, payload, { headers });
  }
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const operid = data;

    return axios.delete(`${url}/workflow/opermgr/${operid}`, {
      headers,
    });
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operId = data.operid;
    let payload = {
      fecDesde: data.from + "T00:00:00.000Z",
      nivelId: data.level,
    };
    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.to && !data.haNoEx) {
      payload = {
        ...payload,
        fecHasta: data.to + "T00:00:00.000Z",
      };
    }

    return axios
      .patch(`${url}/workflow/opermgr/${operId}`, payload, { headers })
      .then(() => {});
  }
}
export default service;
